module.exports = __webpack_public_path__ + "img/Carbon1.14074c62.jpg";